import React from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ACTIVE_MARATHON_PARTICIPANTS_PATH, GENERAL_MARATHON_RESULTS, MARATHON_PHOTO_GALLERY_PATH } from "pages/paths";
import { FlagImg, HomePage, Users, GalleryImg } from "assets/icons";
import styles from './DrawerNavItems.module.scss';
import { useAppSelector } from 'shared/lib/hooks/hooks';

type DrawerNavItemsProp = {
  handleDrawerToggle: () => void;
}

const DrawerNavItems: React.FC<DrawerNavItemsProp> = ({ handleDrawerToggle }): JSX.Element => {
  const { t } = useTranslation();
  const isAuth = useAppSelector((state) => state.users.isAuth);

  const drawerNavItems = [
    { icon: <HomePage />, label: t('header.main'), path: '' },
    { icon: <Users />, label: t('header.listOfParticipants'), path: ACTIVE_MARATHON_PARTICIPANTS_PATH },
    { icon: <FlagImg />, label: t('header.marathonResults'), path: GENERAL_MARATHON_RESULTS },
    ...(isAuth
      ? []
      : [
        {
          icon: <GalleryImg />,
          label: t('header.photoGallery'),
          path: MARATHON_PHOTO_GALLERY_PATH
        }
      ])
  ];


  return (
    <ul className={styles.drawerNavItemsContainer}>
      {drawerNavItems.map((item, index) => (
        <React.Fragment key={index}>
          {item.path === '' ? (
            <li>
              {item.icon}
              <a
                onClick={handleDrawerToggle}
                href="https://runthesilkroad.com/"
                rel="noreferrer"
                style={{ textAlign: 'left' }}
                target="_blank">
                {item.label}
              </a>
            </li>
          ) : (
            <li onClick={handleDrawerToggle}>
              {item.icon}
              <Link to={item.path} style={{ textAlign: 'left' }}>
                {item.label}
              </Link>
            </li>
          )}
        </React.Fragment>
      ))}
    </ul>
  );
};

export default DrawerNavItems;
